<template>
    <transition name="slip" v-on:after-leave="afterLeave">
        <div class="selector-pick-container" :style="{height : '100%',top:top,left:left,position:position}" v-show="visible">
            <slot></slot>
        </div>
    </transition>
</template>
<script>
var isBh = function() {
    return /iphone/.test(navigator.userAgent.toLowerCase()) && !/micromessenger/.test(navigator.userAgent.toLowerCase());
};

export default {

    name: 'bsTransitionPage',

    props: ['value'],

    data() {
        return {
            visible: this.value,
            top: 0,
            left: 0,
            position: 'fixed'
        };
    },
    watch: {
        value(val) {
            this.visible = val;
        },
        visible(val) {
            if (val) {
                history.pushState('', null, '#/smile-select');
            }
            this.$emit('input', val);
        }
    },

    mounted() {
        window.addEventListener("popstate", this.historyChange);
        //ios唤起软键盘后，position:fixed失效
        console.log('去掉ios的isbh')
        // if (isBh()) {
        //     let $input = this.$el.querySelector('input[type="search"]');
        //     if ($input) {
        //         this.bindTouch();
        //         $input.addEventListener('focus', this.foucusSetPosition);
        //         $input.addEventListener('blur', () => {
        //             this.top = 0;
        //             this.left = 0;
        //             this.position = 'fixed';
        //         });
        //     }
        // }
    },
    beforeDestroy() {
        window.removeEventListener("popstate", this.historyChange);
    },

    methods: {
        bindTouch() {
            var startY;
            var $vm = this;
            this.$el.addEventListener('touchstart', function(e) {
                startY = e.touches[0].clientY;
            });

            this.$el.addEventListener('touchmove', function(e) {
                var ele = this;

                var currentY = e.touches[0].clientY;
                let stopEvent = function(el) {
                    if (el == ele) {
                        e.preventDefault();
                        return;
                    }
                    let overflowY = el.style.overflowY;
                    if (overflowY === 'auto' || overflowY === 'scroll') {
                        if (el.offsetHeight >= el.scrollHeight) {
                            e.preventDefault();
                            return
                        }
                        let up = currentY - startY > 0;
                        if (el.scrollTop <= 0) {
                            if (up) {
                                $vm.setPosition();
                                e.preventDefault();
                                return
                            }
                        }
                        if (el.scrollTop + el.offsetHeight >= el.scrollHeight) {
                            if (!up) {
                                $vm.setPosition();
                                e.preventDefault();
                                return
                            }
                        }
                    } else {
                        stopEvent(el.parentNode);
                    }
                }
                stopEvent(e.target)
            });

        },
        foucusSetPosition() {
            let timer = setInterval(this.setPosition, 20);
            setTimeout(() => {
                clearInterval(timer);
                this.setPosition();
            }, 200);
        },
        setPosition() {
            let position = this.$el.parentNode.getBoundingClientRect();
            this.left = '-' + position.left + 'px';
            this.top = '-' + position.top + 'px';
            this.position = 'absolute';
        },
        historyChange() {
            this.visible = false;
        },
        afterLeave(){
            document.activeElement.blur();
        }
    }
};
</script>
<style lang="css" scoped>
.slip-enter-active,
.slip-leave-active {
    transition: transform .25s
}

.slip-enter,
.slip-leave-to {
    transform: translateX(100%);
}

.selector-pick-container {
    position: fixed;
    width: 100vw;
    height: 100%;
    left: 0;
    top: 0;
    overflow: auto;
    background-color: #f9f9f9;
    z-index: 999;
}
</style>


// WEBPACK FOOTER //
// bsTransitionPage.vue?32e282e2